import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-284">
      <div className="max-w-5xl mx-auto" data-id="element-285">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-286">
          <div data-id="element-287">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-288">
              +500
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-289">
              Docentes confían
            </div>
          </div>
          <div data-id="element-290">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-291">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-292">
              Tomos completos
            </div>
          </div>
          <div data-id="element-293">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-294">6</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-295">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-296">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-297">
              4.9/5
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-298">
              Calificación ⭐
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-299">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-300">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-301">
              MG
            </div>
            <div data-id="element-302">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-303">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-304">
                "Organicé todo el año en una tarde. El solucionario me ahorra
                horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-305">
                — M.G., Docente de Italiano
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-306">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-307">
              LP
            </div>
            <div data-id="element-308">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-309">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-310">
                "El Congiuntivo por fin se entiende. Los tomos de gramática
                visual son el punto más alto de cada clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-311">
                — L.P., Instituto de Idiomas
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-312">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-313">
              RM
            </div>
            <div data-id="element-314">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-315">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-316">
                "Mis clases de B2 por fin enganchan a los estudiantes. El Tomo
                C1/C2 vale cada centavo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-317">
                — R.M., Docente de Italiano
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}